(function () {
    'use strict';

    angular
        .module('Lavpop-store.configs', [])
        .config(StConfig)
        .config(InterceptorConfig);

    /** @ngInject */
    function StConfig(stConfig) {
        stConfig.sort.delay = 100;
        stConfig.pipe.delay = 700;
    }

    /** @ngInject */
    function InterceptorConfig($httpProvider) {
        $httpProvider.interceptors.push('cacheFileFactory');
        $httpProvider.interceptors.push('authenticationFactory');
    }
}());